import React from 'react';
import {Image} from 'react-native';

export default function PageNotFound({ width, height } : SvgProps) {
  return <Image style={{ width, height }} source={require('./undraw_page_not_found_re_e9o6.svg')} />
};

